import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  imports: [MatBadgeModule, MatButtonModule, MatIconModule, MatMenuModule],
  exports: [MatBadgeModule, MatButtonModule, MatIconModule, MatMenuModule],
})
export class MaterialModule {}
